export const DAO_CODE = 'DEAL_TAGS' + '_DAO';
